export default "__VITE_ASSET__Cm_A0pXQ__"